import { useEffect, useMemo, useState } from "react";
import {
  Container,
  ContainerRow,
  ContainerView,
} from "../../../components/Container";
import { Form } from "antd";
import { useApp } from "../../../contexts";
import {
  WalletConvertInfo,
  WalletConvertInfoItem,
  WalletConvertInfoItemTitle,
  WalletConvertInfoItemValue,
} from "../../wallet-detail/styles";
import {
  FormButton,
  FormInputNumberRaw,
  FormItemRow,
  FormSelect,
} from "../../../components/Form";
import {
  errorView,
  formatCurrency,
  getWalletList,
  getWithdrawFee,
  ssoGetUserInfo,
  postWithdraw,
  getAddressBookList,
} from "../../../services/app";
import ModalWithdraw from "../modal";
import produce from "immer";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TitleWithBack } from "../../../components/Layout";
import {
  StepBody,
  StepHead,
  Steps,
  Step,
  WithdrawFormContainer,
} from "../styles";
import { ModalAdd } from "../../../components/AddressBooking/ModalAdd";

import { TYPE_WALLET_DETAIL } from "../../../constants";
import { error, success } from "../../../Notification";
import { isSOTd } from "../../../utils/helper";
import { ModalPasswordRequired } from "../../../components/ModalPasswordRequired";
import { useRef } from "react";
import WithdrawSelectAddress from "../../../components/AddressBooking/WithdrawSelectAddress";

export default function WithDrawCrypto(props) {
  const {
    T,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    currencies,
    loadContextData,
    setLoading,
  } = useApp();

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const code = useMemo(() => {
    return searchParams.get("code") ?? "";
  }, [searchParams]);

  const walletId = useMemo(() => {
    return searchParams.get("walletId") ?? "";
  }, [searchParams]);

  const type = useMemo(() => {
    return searchParams.get("type") ?? "";
  }, [searchParams]);
  
  const [fee, setFee] = useState(0);
  const [form] = Form.useForm();

  const [modal, setModal] = useState(null);
  useEffect(() => {
    const modalParam = searchParams.get("modal");
    if (modalParam) {
      setModal(JSON.parse(decodeURIComponent(modalParam)));
    } else {
      setModal(null);
    }
  }, [searchParams]);

  const [available, setAvailable] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [showSetPassword, setShowSetPassword] = useState(false);
  const [wallets, setWallets] = useState([]);
  const selectRef = useRef(null);
  const [addressOptions, setAddressOptions] = useState([]);
  const [addressAdd, setAddressAdd] = useState("");
  const [formData, setFormData] = useState({});
  const [wallet, setWallet] = useState(code);
  const [errors, setErrors] = useState([]);
  const isOption = type === TYPE_WALLET_DETAIL.OPTION;
  // is option

  useEffect(() => {
    if (code) {
      form.setFieldsValue({
        coin: currencies.find((x) => x.code === code) ? code : "",
      });
      setWallet(code);
    }
    loadData();
  }, [code]);

  const onBack = () => {
    navigate(-1);
  };

  const loadData = async () => {
    setLoading(true);
    let result = await getWalletList();
    if (result.status === 200) {
      const items = result?.data?.data?.wallets?.rows || [];
      setWallets(items);
    }
    setLoading(false);
  };

  const loadFee = async (amount, currencyCode) => {
    let result = await getWithdrawFee(amount, currencyCode);
    if (result?.status === 200) {
      setFee(result?.data?.data || 0);
    }
  };
  const checkUserHasPassword = async () => {
    try {
      let result = await ssoGetUserInfo();
      if (result?.data?.data?.has_password) {
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  };
  const onConvert = async (values) => {
    const validatePassword = await checkUserHasPassword();
    if (!validatePassword) {
      setShowSetPassword(true);
      return;
    }
    setLoading(true);
    const result = await postWithdraw({
      fromWalletId: row?.id,
      destWalletAddress: values.to,
      amount: values.amount,
    });
    setLoading(false);
    if (result.status === 200) {
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev);
          params.set(
            "modal",
            encodeURIComponent(
              JSON.stringify({
                ...(result?.data?.data || {}),
                ...(result?.data?.data?.dataValues || {}),
              })
            )
          );
          return params;
        },
        {
          replace: true,
        }
      );
      loadContextData();
    } else {
      setErrors(result?.data?.error?.validates || []);
      if (!(result?.data?.error?.validates || []).length) {
        error(
          result?.data?.error?.message ||
            T("Failed to create a withdrawal request")
        );
      }
    }
  };

  const convertData = () => {
    let itemWallet = wallets.find((item) => item.currency_code === wallet);
    const data = {
      wallets: wallets.map((item) => {
        return {
          ...item,
          coin: item.currency_code,
          amount: item.dog_food,
          btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
          local: convertToLocalCurrency(
            item.dog_food,
            item.currency_code,
            getCurrency()
          ),
        };
      }),
      wallet: itemWallet
        ? {
            ...itemWallet,
            coin: itemWallet.currency_code,
            amount: itemWallet.dog_food,
            btc: convertToBTC(
              itemWallet.dog_food,
              itemWallet.currency_code,
              getCurrency()
            ),
            local: convertToLocalCurrency(
              itemWallet.dog_food,
              itemWallet.currency_code,
              getCurrency()
            ),
          }
        : {},
    };
    if (isOption && form) {
      form.setFieldValue("amount", data?.wallet?.amount || 0);
    }
    return data;
  };

  const onUpdateData = () => {
    const values = form.getFieldsValue();
    setFormData(values);
    if (values.coin && values.amount) {
      loadFee(values.amount, values.coin);
    }
    setAvailable(values.coin && values.amount && values.to);
  };

  const onTransactionHistory = () => {
    let codeOrigin = code;
    let idOrigin = walletId;
    if (row.currency_code) {
      codeOrigin = row.currency_code;
    }
    if (row.id) {
      idOrigin = row.id;
    }
    navigate(
      `/wallet-detail/${type}?code=${codeOrigin || ""}&walletId=${idOrigin}`
    );
  };
  const onSetPassword = () => {
    navigate(`/change-password`);
  };
  const rows = convertData().wallets || [];
  const row = convertData().wallet || {};
  const renderOption = () => {
    if (isOption || isSOTd(code)) {
      const SOTdsObj = {};
      const listSOTds = [...(wallets ?? [])].filter((item) =>
        isSOTd(item.currency_code)
      );
      listSOTds.forEach((item) => {
        SOTdsObj[item.currency_code] = item.can_auto_withdraw;
      });
      const listCurrentCies = currencies?.filter(
        (item) => !!SOTdsObj[item.code]
      );

      return listCurrentCies.map((item, index) => {
        return (
          <FormSelect.Option key={index.toString()} value={item.code}>
            {T(`${item.name} (${item.code})`)}
          </FormSelect.Option>
        );
      });
    } else {
      return currencies.map((item, index) => {
        return item.code === code ? (
          <FormSelect.Option key={index.toString()} value={item.code}>
            {T(`${item.name} (${item.code})`)}
          </FormSelect.Option>
        ) : null;
      });
    }
  };
  const initAddressOptions = () => {
    getAddressBookList({
      keyword: "",
      network: "eth",
      limit: 500,
    }).then((res) => {
      const options = (res?.data?.data?.rows || []).map((item) => ({
        value: item.address,
        label: item.name,
      }));
      setAddressOptions(options);
    });
  };
  useEffect(() => {
    initAddressOptions();
  }, []);

  return rows?.length ? (
    <Container>
      <ContainerView>
        <TitleWithBack title={T("Withdrawal Request")} onClick={onBack} />
        <Steps>
          <Step>
            <div>
              <StepHead>
                <img src="/assets/images/otc/step1.svg" />
                <span>{T("Select Coin")}</span>
              </StepHead>
              <StepBody>
                {T("Select the currency that you want to withdraw")}
              </StepBody>
            </div>
            <div className={"arrow"} />
          </Step>
          <Step>
            <div>
              <StepHead>
                <img src="/assets/images/otc/step2.svg" />
                <span>{T("Enter Information")}</span>
              </StepHead>
              <StepBody>
                {T(
                  "Copy and paste the deposit address and enter the amount you want to send"
                )}
              </StepBody>
            </div>
            <div className={"arrow"} />
          </Step>
          <Step>
            <div>
              <StepHead>
                <img src="/assets/images/otc/step3.svg" />
                <span>{T("Wait for Approval")}</span>
              </StepHead>
              <StepBody>
                {T("Please wait while we review your request")}
              </StepBody>
            </div>
            <div className={"arrow"} />
          </Step>
          <Step>
            <div>
              <StepHead>
                <img src="/assets/images/otc/step4.svg" />
                <span>{T("Receive Result")}</span>
              </StepHead>
              <StepBody>
                {T("Deposit successfully sent to recipient’s address")}
              </StepBody>
            </div>
          </Step>
        </Steps>

        <WithdrawFormContainer>
          <Form
            form={form}
            onFinish={() => {
              onConvert(form.getFieldsValue());
            }}
            onValuesChange={() => {
              onUpdateData();
            }}
          >
            <FormItemRow
              {...errorView(errors, "fromWalletId")}
              name={"coin"}
              label={T("Coin")}
              initialValue={currencies.find((x) => x.code === code) ? code : ""}
              rules={[{ required: true, message: T("Coin is required!") }]}
            >
              <FormSelect
                onChange={(value) => {
                  if (!!value) {
                    setWallet(value);
                  }
                  form.setFieldValue("to", "");
                  form.setFieldValue("amount", "");
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex((item) => item.key === "fromWalletId"),
                        1
                      );
                    })
                  );
                }}
              >
                {renderOption()}
              </FormSelect>
            </FormItemRow>
            {/* <FormItemRow
              {...errorView(errors, "destWalletAddress")}
              name={"to"}
              label={T("Recipient’s address")}
              rules={[{ required: true, message: "" }]}
              className="column-reserved"
              extra={
                <div className="flex justify-start items-start lg:items-center gap-2 mb-3">
                  <div className="note-icon w-[20px] h-[20px] mt-2 lg:mt-0">
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={"/assets/images/alert.svg"}
                      alt=""
                      className="object-contain"
                    />
                  </div>
                  <div
                    className="flex-1 text-[13px]"
                    dangerouslySetInnerHTML={{
                      __html: T("withdraw.alert_eth"),
                    }}
                  ></div>
                </div>
              }
            >
              <FormInput
                onChange={() => {
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex(
                          (item) => item.key === "destWalletAddress"
                        ),
                        1
                      );
                    })
                  );
                }}
                placeholder={T("Please enter the recipient’s address")}
              />
            </FormItemRow> */}
            <FormItemRow
              {...errorView(errors, "destWalletAddress")}
              name={"to"}
              label={T("Recipient’s address")}
              rules={[
                { required: true, message: "Recipient’s address is required!" },
              ]}
              className="column-reserved"
              extra={
                <div className="flex justify-start items-start lg:items-center gap-2 mb-3">
                  <div className="note-icon w-[20px] h-[20px] mt-2 lg:mt-0">
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={"/assets/images/alert.svg"}
                      alt=""
                      className="object-contain"
                    />
                  </div>
                  <div
                    className="flex-1 text-[13px]"
                    dangerouslySetInnerHTML={{
                      __html: T("withdraw.alert_eth"),
                    }}
                  ></div>
                </div>
              }
            >
              <WithdrawSelectAddress
                options={addressOptions}
                ref={selectRef}
                value={formData.to}
                placeholder={T("Please enter the recipient’s address")}
                className="input-mint"
                onAddAddress={(address) => {
                  setOpenAdd(true);
                  setAddressAdd(address);
                }}
                onChange={() => {
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex(
                          (item) => item.key === "destWalletAddress"
                        ),
                        1
                      );
                    })
                  );
                }}
              />
              {/* <FormSelect
                showSearch
                ref={selectRef}
                placeholder={T("Please enter the recipient’s address")}
                className="input-mint"
                defaultActiveFirstOption={false}
                suffixIcon={null}
                prefixIcon={<>a</>}
                filterOption={false}
                showArrow={false}
                onSearch={fecthAddressItems}
                onChange={() => {
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex(
                          (item) => item.key === "destWalletAddress"
                        ),
                        1
                      );
                    })
                  );
                }}
                notFoundContent={isAddress(searchKey) ? 
                <span className="text-aia-red-400" onClick={() => {setOpenAdd(true); selectRef.current?.blur();}}>
                  {T('+ Add this address to your address book')}
                </span>: searchKey ? <span className="text-red-500">{T('Not found this name in address book')}</span>: null}
                options={addressOptions || []}
              /> */}
            </FormItemRow>
            <FormItemRow
              initialValue={isOption ? row?.amount : undefined}
              {...errorView(errors, "amount")}
              name={"amount"}
              label={T("Amount")}
              rules={[{ required: true, message: T("Amount is required!") }]}
            >
              <FormInputNumberRaw
                readOnly={isOption}
                onChange={() => {
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex((item) => item.key === "amount"),
                        1
                      );
                    })
                  );
                }}
                min={0}
                onAll={() => {
                  form.setFieldValue("amount", parseFloat(row?.amount));
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex((item) => item.key === "amount"),
                        1
                      );
                    })
                  );
                  onUpdateData();
                }}
                addonAfter={row?.coin || ""}
                placeholder={T(`Please enter the {coin} amount`).replace(
                  "{coin}",
                  row?.coin || ""
                )}
              />
            </FormItemRow>

            <ContainerRow style={{ marginTop: 41, marginBottom: 41 }}>
              <WalletConvertInfo style={{ flex: 1 }}>
                <WalletConvertInfoItem>
                  <WalletConvertInfoItemTitle>
                    {T("Balance")}
                  </WalletConvertInfoItemTitle>
                  <WalletConvertInfoItemValue
                    style={{ marginLeft: 0 }}
                    className={"text-aia-red"}
                  >
                    {formatCurrency(row?.amount || 0, null, getCurrency())}{" "}
                    {row?.coin}
                  </WalletConvertInfoItemValue>
                </WalletConvertInfoItem>
                <WalletConvertInfoItem>
                  <WalletConvertInfoItemTitle>
                    {T("Fee")}
                  </WalletConvertInfoItemTitle>
                  <WalletConvertInfoItemValue style={{ marginLeft: 0 }}>
                    {formatCurrency(fee, null, getCurrency())} {row?.coin}
                  </WalletConvertInfoItemValue>
                </WalletConvertInfoItem>
              </WalletConvertInfo>
            </ContainerRow>

            <Container>
              <FormButton
                disabled={!available}
                htmlType={"button"}
                onClick={() => {
                  form.submit();
                }}
              >
                {T("Withdraw")}
              </FormButton>
            </Container>
          </Form>
        </WithdrawFormContainer>
      </ContainerView>
      {openAdd && (
        <ModalAdd
          title={"Add new address"}
          onSubmit={(address) => {
            setOpenAdd(false);
            form.setFieldValue("to", address);
            initAddressOptions();
            setTimeout(() => {
              onUpdateData();
            }, [200]);
          }}
          isWithdraw={true}
          defaultAddress={addressAdd}
          defaultNetwork={"eth"}
          onClose={() => setOpenAdd(false)}
        />
      )}
      {modal ? (
        <ModalWithdraw
          onClose={(value) => {
            setSearchParams(
              (prev) => {
                const params = new URLSearchParams(prev);
                params.delete("modal");
                return params;
              },
              {
                replace: true,
              }
            );
            if (value) {
              value === "success"
                ? success(T("Withdrawal request has been created"))
                : error(T("Failed to create a withdrawal request"));
              if (value === "success") {
                setAvailable(false);
                form.resetFields();
                onTransactionHistory();
              }
            }
            loadData();
          }}
          value={modal}
        />
      ) : null}
      {showSetPassword && (
        <ModalPasswordRequired
          onClose={() => setShowSetPassword(false)}
          onSubmit={() => onSetPassword()}
        />
      )}
    </Container>
  ) : null;
}
